import * as Actions from '../actions';

export default function toggleReducer(state = false, action) {
	switch (action.type) {
		case Actions.TOGGLE_SEARCH_COMPLETE:
			return action.toggle;
		default:
			return state;
	}
}